module.exports = __webpack_public_path__ + "img/eu_logo_small.5abc4bd6.png";